import React from "react";
import "./About.css";

import aboutBG from "../../Images/Backgrounds/aboutBG.png";
import about1 from "../../Images/Content/about1.png";
import about2 from "../../Images/Content/about2.png";
import about3 from "../../Images/Content/about3.png";

function About() {
  return (
    <div className="about-container">
      {" "}
      <div className="whyMedaHero"></div>
      <section className="about-page">
        <div className="about-intro" id="about-content">
          <h1>About MedaHealth</h1>
          <p>
            Established in 2022, MedaHealth has quickly become a trusted name in
            health insurance, serving thousands of clients across all 50 states.
            Our team brings together over a century of combined experience in
            the insurance industry, blending modern tools with time-tested
            expertise.
          </p>
          <p>
            At MedaHealth, we understand that health insurance isn’t just about
            policies and premiums—it’s about peace of mind. Whether you’re an
            individual seeking the right plan, a family looking for
            comprehensive coverage, or a business aiming to protect your team,
            we’re here to guide you every step of the way.
          </p>
          <img src={about1} className="aboutImage"></img>
        </div>

        <div className="about-mission" id="about-content">
          <h2>Our Mission & Values</h2>
          <p>
            Our mission is simple: to make health insurance human again. We
            believe everyone deserves access to clear, affordable coverage and
            compassionate guidance. Our values are rooted in transparency,
            integrity, and empathy. We don’t just sell policies—we advocate for
            people.
          </p>
          <p>
            We pride ourselves on making the complex simple. Health insurance
            can feel overwhelming, but our streamlined process, clear
            explanations, and personalized support ensure that you never feel
            lost in the details. From selecting a plan to navigating claims, we
            stand by our clients as partners in health and financial security.
          </p>
          <img src={about2} className="aboutImage"></img>
        </div>

        <div className="about-why" id="about-content">
          <h2>Why Choose Us?</h2>
          <p>
            With MedaHealth, you’re never just a number. Our advisors take the
            time to understand your unique needs and craft solutions that fit
            both your lifestyle and your budget. We work with top carriers in
            every state, giving you access to the best options—without the
            pressure.
          </p>

          <p>
            Looking ahead, we remain committed to expanding our reach, improving
            our services, and staying at the forefront of an ever-changing
            industry. At MedaHealth, your health and your trust are at the heart
            of everything we do.
          </p>
          <img src={about3} className="aboutImage"></img>
        </div>
        <div className="about-cta">
          <h2>Would you like some help considering your options?</h2>
          <a href="/quote" className="about-cta-button">
            Get a Free Quote
          </a>
        </div>
      </section>
    </div>
  );
}

export default About;
